// @flow
import ViewControls from './ViewControls';

export default ViewControls;
